import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  fetchProjectsByMemberId,
  fetchProjectsByOwnerId,
} from "store/slices/projectsSlice";
import MainLayout from "layouts/MainLayout";
import { useTranslation } from "react-i18next";
import ProjectPost from "components/Project/ProjectPost";
import styled from "styled-components";
import themeProps from "theme/themes";
import { ProjectsEnum } from "common/enums/projects";

const TypesWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const ProjectTypeBasic = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  margin-right: 28px;
  font-size: 1.8rem;
  font-weight: 700;
  cursor: pointer;
`;

const ProjectType = styled(ProjectTypeBasic)(
  ({ selected }: { selected: boolean }) => ({
    color: selected
      ? `#7D02FA`
      : `${(state: themeProps) => state.theme.text.primary}`,
  })
);

const Projects = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("nav");
  const [typeSelected, setTypeSelected] = useState(ProjectsEnum.CREATED);
  const createdProjects = useAppSelector(
    (state) => state.projects.createdProjects
  );
  const joinedProjects = useAppSelector(
    (state) => state.projects.joinedProjects
  );
  const userId: any = useAppSelector((state) => state.user.auth.userId);

  useEffect(() => {
    dispatch(fetchProjectsByOwnerId(userId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainLayout heading={t("projects")}>
      <TypesWrapper>
        <ProjectType
          selected={typeSelected === ProjectsEnum.JOINED}
          onClick={() => {
            dispatch(fetchProjectsByMemberId(userId));
            setTypeSelected(ProjectsEnum.JOINED);
          }}
        >
          {t("project:joinedProjects")}
        </ProjectType>
        <ProjectType
          selected={typeSelected === ProjectsEnum.CREATED}
          onClick={() => {
            dispatch(fetchProjectsByOwnerId(userId));
            setTypeSelected(ProjectsEnum.CREATED);
          }}
        >
          {t("project:createdProjects")}
        </ProjectType>
      </TypesWrapper>
      {createdProjects &&
        typeSelected === ProjectsEnum.CREATED &&
        createdProjects?.map((project, index) => (
          <ProjectPost key={index} project={project} />
        ))}
      {joinedProjects &&
        typeSelected === ProjectsEnum.JOINED &&
        joinedProjects?.map((project, index) => (
          <ProjectPost key={index} project={project} />
        ))}
    </MainLayout>
  );
};

export default Projects;
